module.exports = __webpack_public_path__ + "img/feature-card4.fa8809e0.png";